import React, { createContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { Form } from 'semantic-ui-react';
import { useAuth } from 'services/auth';
import { LoginForm } from './components/LoginForm';
import { ActivateAccount } from './components/ActivateAccount';
import { useInitPassReset } from 'services/auth/init-pass-reset/hook';
import { BasicPageLayout } from 'components/layout/BasicPageLayout';
import { PageLoader } from 'components/loaders/PageLoader';

export const LoginContext = createContext(null);

const LogIn = () => {
  const { isAuthenticated, userTenants, authLoading } = useAuth();
  const [shouldActivateAccount, setShouldActivateAccount] = useState(false);
  const [email, setEmail] = useState('');

  const { isInitSuccessful } = useInitPassReset();

  useEffect(() => {
    if (isInitSuccessful) {
      setShouldActivateAccount(true);
    }
  }, [isInitSuccessful, setShouldActivateAccount]);

  if(authLoading){
    return <PageLoader />
  }

  return (
    <LoginContext.Provider value={{
      email,
      setEmail,
      setShouldActivateAccount,
    }}
    >
      {/* eslint-disable-next-line no-nested-ternary */}
      {isAuthenticated
        ? (
          userTenants?.length > 1
            ? <Redirect to="/" />
            : <Redirect to={userTenants[0]} />
        )
        : (
          <BasicPageLayout intlTitle="login">
            <Form size="large">
              {shouldActivateAccount ? <ActivateAccount /> : <LoginForm />}
            </Form>
          </BasicPageLayout>
        )}
    </LoginContext.Provider>
  );

};

export default LogIn;
